//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { QCard, QCardSection } from 'quasar'
import humanize from 'humanize'
import moment from 'moment'

export default {
  name: 'TimeTable',
  created: function () {
    moment.locale(this.$store.state.local)
  },
  components: {
    QCard,
    QCardSection
  },
  data () {
    return {
      momentjs: moment,
      humanizejs: humanize,
      pagination: {
        rowsPerPage: 0
      }
    }
  },
  computed: {
    Local: function () {
      return this.$store.state.local
    },
    tableColumns: function () {
      return [
        {
          label: this.$t('time.array.title'),
          name: 'title',
          field: 'title'
        },
        {
          label: this.$t('time.array.date'),
          name: 'date',
          field: 'date'
        },
        {
          label: this.$t('time.array.clock'),
          name: 'clock',
          field: 'clock'
        },
        {
          label: this.$t('time.array.parallelism'),
          name: 'parallelism',
          field: 'parallelism'
        },
        {
          label: this.$t('time.array.operations'),
          name: 'operations',
          field: 'operations'
        },
        {
          label: this.$t('time.array.time'),
          name: 'time',
          field: 'time'
        },
        {
          label: this.$t('time.array.optimizedtime'),
          name: 'optimizedtime',
          field: 'optimizedtime'
        }
      ]
    },
    possibilityAndOperations: function () {
      return this.$store.state.operation.PossibilityAndOperations()
    },
    tableData: function () {
      const comparator = this.$store.state.operation.Comparator()
      const table = []
      comparator.forEach(item => {
        table.push({
          title: item.Title,
          date: item.Date,
          clock: item.Cpu,
          parallelism: this.humanizejs.numberFormat(item.Para, 0, ',', ' '),
          operations: this.humanizejs.numberFormat(item.Unit, 0, ',', ' '),
          time: this.momentjs(new Date().getTime() + item.Time).fromNow(),
          optimizedtime: this.momentjs(
            new Date().getTime() + item.TimeOptimyze
          ).fromNow()
        })
      })
      return table
    }
  }
}
